// extracted by mini-css-extract-plugin
export var divider = "_ob-0";
export var systemMessage = "_ob-1";